var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu Dots"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 308",
    cx: 17.25,
    cy: 12.25,
    r: 1.25,
    transform: "rotate(90 17.25 12.25)",
    fill: "#1E2D66"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 309",
    cx: 12.25,
    cy: 12.25,
    r: 1.25,
    transform: "rotate(90 12.25 12.25)",
    fill: "#1E2D66"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 310",
    cx: 7.25,
    cy: 12.25,
    r: 1.25,
    transform: "rotate(90 7.25 12.25)",
    fill: "#1E2D66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/Menu_Dots.f3fb55ef378d2c70e586b0c6150697a7.svg";
export { ForwardRef as ReactComponent };